import { useEffect, useMemo, useState } from 'react'
import type { IFilterData } from '@rankmi/rankmi-table/dist/interfaces/filterProps'

import listActiveParticipants, {
  UsersSearchParams,
} from 'api/administration/participants/ListActiveParticipants'
import { UserAttributes } from 'api/administration/participants/types'
import TableUsers from 'components/ui/TableUsers'
import { useUsersColumns } from '../../lms-profiles/common/hooks'

interface TableProps {
  filterData?: IFilterData
}

export const Table = ({ filterData }: TableProps) => {
  const [search, setSearch] = useState('')
  const [sort, setSort] = useState({})
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(10)
  const [fastFilters, setFastFilters] = useState(0 as any)

  const [loading, setLoading] = useState(false)
  const [list, setList] = useState<UserAttributes[]>([])
  const [total, setTotal] = useState(0)

  const params = useMemo(
    (): Omit<UsersSearchParams, 'page' | 'perPage'> => ({
      searchText: search,
      sort,
      usersFilter: filterData,
      fastFilters,
    }),
    [search, filterData, sort, fastFilters]
  )

  useEffect(() => {
    setLoading(true)
    listActiveParticipants({
      page,
      perPage,
      ...params,
    })
      .then(({ data, total }) => {
        setList(data)
        setTotal(total)
      })
      .finally(() => setLoading(false))
  }, [page, params, perPage])

  const dataSource = useMemo(
    () =>
      list.map((user) => ({
        key: user.id,
        ...user,
      })),
    [list]
  )

  const columns = useUsersColumns()

  const handleSearch = (value: string) => {
    setSearch(value)
    setPage(1)
  }

  const handleSetFastAction = (value: any) => {
    setFastFilters(value)
    setPage(1)
  }

  return (
    <div>
      <TableUsers
        changeColumnsVisibility
        responsive
        delaySearch
        data={dataSource}
        search={search}
        onSearch={handleSearch}
        total={total}
        columnHeaders={columns}
        onSortChange={(sortData: any) => setSort(sortData)}
        loading={loading}
        onPaginationChange={(currentPage: number) => setPage(currentPage)}
        simpleSelectAll={true}
        onRowsPerPageChange={(itemsPerPage: number) => setPerPage(itemsPerPage)}
        onFastActionSelect={handleSetFastAction}
        showScrollButtons
      />
    </div>
  )
}
